<template>
  <div id="Status" class="mt-0">
      <v-chip
        large
        :color="getColor(status)"
        text-color="white"
      >
        {{ status }}
      </v-chip>
  </div>
</template>
<script>
export default {
  name: "Status",
  props: {
    status: {
      default: () => null,
      type: String,
    },
  },
  methods: {
    getColor(sticksName) {
      switch (sticksName) {
        case "Pendente":
          return "warning";
        case "Entrega Direta":
          return "primary";
        case "Aceito Pelo Transbordo":
          return "primary";
        case "Alocado para Entregador":
          return "primary";
        case "Quarentena de Transferência":
          return "warning";
        case "Entregue Com Sucesso":
          return "green";
        case "Extraviado":
          return "error";
        case "A Devolver":
          return "warning";
        case "Devolvido Com Sucesso":
          return "deep-purple darken-1";
        case "Devolvido Com Pendência":
          return "error";
        case "Devolvido para Reentrega":
          return "error";
        case "Em transferência":
          return "primary";
        case "Quarentena de Entrega":
          return "warning";
        case "Tentar entregar novamente":
          return "warning";
        case "Devolvido Pelo Transbordo":
          return "warning";
        default:
          return "primary";
      }
    },
  },
};
</script>

<style></style>
